<div class="popup day-note-popup">
	<div class="popup-header">
		<div class="popup-title">{{ 'DAY_NOTES.NOTES' | translate }}</div>
		<div class="qo-flex-row-center-right">
			<div class="date-selected">{{(selectedDate$ | async) | smLocalDate:'mediumDate'}}</div>
			<!--<div class="department-image">gg</div>-->
			<div class="department-name">{{(selectedDepartment$ | async).department_name}}</div>
		</div>
	</div>
	<div class="popup-body">
		<div *ngFor="let dayNote of dayNotes" class="qo-card">
			<div class="day-note-header qo-flex-col-top-left">
				<div class="qo-flex-row-space-between">
					<div class="qo-flex-row-top-left qo-align-items-center">
						<qo-profile-image
							[letter]="dayNote.user.getInitials()"
							[imageUrl]="(dayNote.user.profile_picture) ? dayNote.user.profile_picture.download_url : undefined"
							[size]="60"
							[fontSize]="26"
						></qo-profile-image>
						<div class="name-and-time">
							<div
								class="name"
								[class.userDeleted]="dayNote.user.deactivated_at"
							>
								{{dayNote.user.getFullName()}}
							</div>
							<div class="time">{{dayNote.updated_at | smLocalDate:'mediumDate'}}</div>
						</div>
					</div>
					<qo-input-dropdown
						*ngIf="dayNote.actions.length !== 0"
						[icon]="EQORebrandIcon.more_dark"
						[invertedScheme]="true"
						[scheme]="EQORebrandColor.SECONDARY"
						[compact]="true"
						[border]="false"
						[actions]="dayNote.actions"
						[size]="'small'"
					></qo-input-dropdown>
				</div>

			</div>
			<div class="day-note-text" [innerHTML]="dayNote.note | linkify"></div>
		</div>
	</div>

	<div class="popup-footer">
		<button class="qo-button-standard qo-grey" (click)="close()">{{ 'GLOBAL.CLOSE' | translate }}</button>
		<button class="qo-button-standard qo-primary" (click)="createNew()"
						*ngIf="(user$ | async).isAdmin()">{{ 'DAY_NOTES.ADD' | translate }}</button>
	</div>
</div>
